"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ElevateYourCreativePresence() {
  const {
    ref: titleRef,
    isVisible: isTitleVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: btnRef,
    isVisible: isBtnVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: mockupRef,
    isVisible: isMockupVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="240934" id="the-chipper-welcome" className="bg-background w-full overflow-hidden dark">
      <div className="grid grid-cols-1 lg:grid-cols-10 min-h-[90vh] w-full">
        
        {}
        <div className="flex flex-col justify-center px-6 py-24 relative z-10 !bg-[rgba(58,41,25,1)] lg:col-span-6 sm:px-12 lg:px-20 xl:px-32">
          <div className="max-w-3xl">
            <h1 ref={titleRef} className={`font-default flex flex-col uppercase transition-all duration-1000 ease-out transform ${isTitleVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`}>
              <span className="text-white text-[4rem] sm:text-[6rem] lg:text-[7rem] xl:text-[120px] font-bold leading-[0.85] tracking-tighter">
                Professional
              </span>
              <span className="text-[3.5rem] sm:text-[5.5rem] lg:text-[6.5rem] xl:text-[110px] font-bold leading-[0.9] tracking-tighter mt-2 sm:mt-4" style={{
              WebkitTextStroke: '2px rgba(255,255,255,0.9)',
              color: 'transparent'
            }}>
                Forestry Mulching
              </span>
            </h1>
            
            <p ref={textRef} className={`text-muted-foreground mt-8 sm:mt-12 max-w-lg text-lg sm:text-xl font-default leading-relaxed transition-all duration-1000 delay-200 ease-out transform ${isTextVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
              Fast, clean, and low-impact property solutions for Burlington, NC. Chipper Mulching Co. delivers expert land clearing that preserves your soil while removing the mess.
            </p>
            
            <div ref={btnRef} className={`mt-12 sm:mt-16 transition-all duration-1000 delay-400 ease-out transform ${isBtnVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-8 py-7 text-lg font-bold tracking-wide animate-[pulse_3s_ease-in-out_infinite] group shadow-lg">
                <Link to="contact-us">
                  Schedule a Site Visit
                  <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="lg:col-span-4 bg-gradient-to-br from-muted to-background flex items-center justify-center py-24 px-6 lg:p-0 relative overflow-hidden">
          
          {}
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-lg mix-blend-multiply filter blur-3xl opacity-50 animate-blob"></div>
          <div className="absolute bottom-0 left-0 w-72 h-72 bg-secondary/20 rounded-lg mix-blend-multiply filter blur-3xl opacity-50 animate-blob animation-delay-2000"></div>

          {}
          <div ref={mockupRef} className="relative w-[280px] sm:w-[340px] lg:w-[380px] aspect-[3/4] rounded-2xl p-2 sm:p-3 shadow-2xl border border-border transition-all duration-1000 delay-300 ease-out opacity-100 scale-100 [&]:[transform:perspective(1200px)_rotateY(-15deg)_rotateX(5deg)] hover:[&]:[transform:perspective(1200px)_rotateY(-5deg)_rotateX(2deg)] bg-primary" style={{
          transitionProperty: 'transform, opacity, scale'
        }}>
            {}
            <div className="w-full h-full bg-white rounded-xl overflow-hidden relative group shadow-inner">
              {}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/3 h-4 bg-secondary rounded-b-xl z-20"></div>
              
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/forestry-mulching-1.png" alt="Chipper Mulching Co Mascot and Equipment" className="w-full h-auto object-cover transition-transform duration-[8000ms] ease-linear group-hover:-translate-y-[60%] relative z-10" src="https://optimum-pug.10web.cloud/wp-content/uploads/2026/05/forestry-mulching-1.jpg" />
              
              {}
              <div className="absolute inset-0 bg-muted flex flex-col gap-4 p-4 pt-8 z-0">
                <div className="w-full h-32 bg-secondary/10 rounded-lg animate-pulse"></div>
                <div className="w-full h-48 bg-primary/10 rounded-lg animate-pulse delay-75"></div>
                <div className="w-full h-40 bg-secondary/10 rounded-lg animate-pulse delay-150"></div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}